import { render, staticRenderFns } from "./ProfessionField.vue?vue&type=template&id=5820aa1d"
import script from "./ProfessionField.vue?vue&type=script&lang=js"
export * from "./ProfessionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports